import { render, staticRenderFns } from "./buscarExpediente.vue?vue&type=template&id=0b7fdeb5&scoped=true"
import script from "./buscarExpediente.vue?vue&type=script&lang=js"
export * from "./buscarExpediente.vue?vue&type=script&lang=js"
import style0 from "./buscarExpediente.vue?vue&type=style&index=0&id=0b7fdeb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fdeb5",
  null
  
)

export default component.exports